import { devtools } from 'config/devtools'
import { create } from 'zustand'

import { UseSelectedStatusTable } from './types'

export const useSelectedStatusTable = create<UseSelectedStatusTable>()(
  devtools(
    (set) => ({
      selectedIds: [],
      setSelectedIds: (state) => {
        set((prev) => {
          const selectedIds = typeof state === 'function' ? state(prev.selectedIds) : state
          return { selectedIds }
        })
      },
      clear: () => set({ selectedIds: [] }),
    }),
    {
      store: 'selectedStatusTable',
    },
  ),
)
